import { styled, css } from 'styled-components';
import { ButtonWrapper } from '../../Controls/Button/styled';
import { ITEM_BORDER_SIZE, ITEM_MIN_HEIGHT } from './constants';
export const ListWrapper = styled.div `
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  ${({ theme, $error }) => $error && theme.shadows.error}
  border: 1px solid ${({ theme, $error }) => ($error ? theme.colors.critical100 : theme.colors.grey30_1)};
  background-color: ${({ theme }) => theme.colors.grey00_7};
`;
export const Header = styled.div `
  padding: 8px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.grey05_1};
  ${({ theme }) => theme.typography.weightDefault}
  ${({ theme }) => theme.typography.textMedium}
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey30_1};
`;
export const ScrollableContainer = styled.div `
  width: 100%;
  height: ${({ height }) => `${height}px`};
  overflow-y: auto;
`;
export const NoDataWrapper = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-align: center;
  padding: 8px;
`;
export const Footer = styled.div `
  padding: 8px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  ${({ theme }) => theme.typography.weightMedium}
  ${({ theme }) => theme.typography.textMedium}
  background-color: ${({ theme }) => theme.colors.grey01_1};
  border-top: 1px solid ${({ theme }) => theme.colors.grey30_1};
`;
export const FooterSortOrder = styled.div `
  cursor: pointer;
  white-space: nowrap;
`;
export const FooterInfo = styled.div `
  color: ${({ theme }) => theme.colors.grey100_1};
`;
export const ListItemWrapper = styled.div `
  position: relative;
  min-height: ${ITEM_MIN_HEIGHT}px;
  padding: 8px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  word-break: break-word;
  border-top: ${ITEM_BORDER_SIZE}px solid ${({ theme }) => theme.colors.grey05_1};
  box-shadow: 0 ${ITEM_BORDER_SIZE}px 0 0 ${({ theme }) => theme.colors.grey05_1};
  transition: background-color linear 150ms;

  &:first-child {
    border-top: none;
  }

  ${({ $scrollbarWidth }) => $scrollbarWidth > 0 &&
    css `
      padding-right: ${18 - $scrollbarWidth}px;
    `}

  ${({ disabled }) => !disabled &&
    css `
      &:has(> ${ButtonWrapper}:hover) {
        background-color: ${({ theme }) => theme.colors.grey01_1};
      }
    `}
`;
export const ListItemLabel = styled.span `
  ${({ theme, disabled }) => disabled &&
    css `
      color: ${theme.colors.grey70_1};
    `}
`;
// #endregion
export const ListItemDescription = styled.p `
  margin: 0;
  color: ${({ theme }) => theme.colors.grey100_1};
  margin-top: 4px;
`;
